import { render } from "./LeaveReport.vue?vue&type=template&id=087a016b&scoped=true"
import script from "./LeaveReport.vue?vue&type=script&lang=js"
export * from "./LeaveReport.vue?vue&type=script&lang=js"

import "./LeaveReport.vue?vue&type=style&index=0&id=087a016b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087a016b"]])

export default __exports__